import React from 'react';
import PropTypes from 'prop-types';
import Money from 'components/formatters/money-formatter';
import './color-money-formatter.scss';

const formatColor = (value) => {
    if (value > 0) {
        return 'positive'
    }

    if (value < 0) {
        return 'negative'
    }

    if (value === 0) {
        return 'neutral'
    }
};

// TODO: Take currency from the global state?
const ColorMoney = ({value, noColor}) => (
    <span className={(!noColor && formatColor(value)) + ' bold'}>
        <Money value={value} />
    </span>
);

Money.propTypes = {
    value: PropTypes.number.isRequired,
    currency: PropTypes.string,
};

export default ColorMoney;


// WEBPACK FOOTER //
// ./src/components/formatters/color-money-formatter.js